import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { CancelButton } from './ui/cancel-button';
import { RotatingDeleteIcon } from './RotatingDeleteIcon';

type DismissAllSuggestionsModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isConfirming?: boolean;
  t: (key: string) => string;
};

export const DismissAllSuggestionsModal: React.FC<DismissAllSuggestionsModalProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isConfirming = false,
  t,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('dismiss_all_suggestions_title')}</DialogTitle>
          <DialogDescription>{t('dismiss_all_suggestions_message')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <CancelButton onClick={() => onOpenChange(false)} disabled={isConfirming}>
            {t('cancel')}
          </CancelButton>
          <Button
            variant="destructive"
            dialogPrimary
            disabled={isConfirming}
            onClick={() => {
              void onConfirm();
            }}
            className="group inline-flex items-center gap-1.5"
          >
            <RotatingDeleteIcon />
            {t('dismiss_all_suggestions_confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
